export interface Input {
  code: number;
}

const/code=input.code
let/curr=input.code

<script>
  if (curr !== code) {
    if (curr < code) {
      curr++;
    } else {
      curr--;
    }
  }  
</script>

span -- ${String.fromCharCode(curr)}
